import styled from 'styled-components'
import { Themes } from '@src/styles/theme'

const primary = '#33AA40'
const primaryHover = '#0E7923'
const secondary = '#394E5B'
const accent = '#3292C0'
const background = '#1F313A'

export const MarketingPageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  min-height: 60vh;
  color: ${(p: any) => (p.theme?.selected === Themes.LIGHT ? '#1F313A' : '#FFFFFF')};

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`

export const MarketingSection = styled.section`
  margin-bottom: 3rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: inherit;

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`

export const PageSubtitle = styled.p`
  font-size: 1.125rem;
  opacity: 0.9;
  margin-bottom: 2rem;
  color: inherit;
`

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: ${(p: any) =>
    p.theme?.selected === Themes.LIGHT ? 'rgba(255,255,255,0.95)' : 'rgba(31, 49, 58, 0.9)'};
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`

export const FooterContainer = styled.footer`
  background: ${(p: any) =>
    p.theme?.selected === Themes.LIGHT ? '#e9ecef' : secondary};
  color: #fff;
  padding: 3rem 2rem 2rem;
  margin-top: auto;
`

export const FooterLinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 140px;
`

export const FooterLink = styled.a`
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  font-size: 0.875rem;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`

export const DesktopNavWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`

export const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: inherit;

  @media (max-width: 768px) {
    display: block;
  }
`

export const MobileNav = styled.nav`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: inherit;
  padding: 1rem;
  flex-direction: column;
  gap: 0.75rem;

  @media (max-width: 768px) {
    &.open {
      display: flex;
    }
  }
`
